// extracted by mini-css-extract-plugin
export default {"header":"header_header__3lgq7","header__logo":"header_header__logo__SJ7zc"};